import { Button } from '@nextui-org/react'
import React from 'react'
import { Route } from '../../../routers/routes'
import CardDefault from '../cards/CardDefault'
import Link from 'next/link'
import { usePathname } from 'next/navigation';


export default function LoginSuggestion(props) {
  const { variant = 'default' } = props
  const pathname = usePathname()

  const renderDefault = () => {
    return (
      <>
        <CardDefault>
          <div className="flex flex-col items-center justify-center">
            <p className="mb-4">You need to be logged in to post a comment</p>
            <Link href={Route.login(pathname)}>
              <Button color="primary" auto >Login</Button>
            </Link>
          </div>
        </CardDefault>
      </>
    )
  }

  const renderSmall = () => {
    return (
      <>
        <div className="flex flex-col items-center justify-center">
          <p className="mb-2 text-sm text-center underline">
            <Link href={Route.login(pathname)}>
              Please login to post a comment
            </Link>
          </p>
        </div>
      </>
    )
  }

  const customRender = () => {
    if (variant == "default") return renderDefault()
    if (variant == "small") return renderSmall()
  }
  return (
    <>
      {customRender()}
    </>

  )


}
